import $ from 'jquery';
import fancybox from 'fancybox';

export default function() {
  fancybox($);
  var $articleImages = $('.article a:has(img:not(.attachment-thumbnail))');

  $articleImages
    .attr('rel', 'images')
    .fancybox();

    $articleImages.children('img').each(function(index, element) {
      $(element)
        .parent()
        .attr('title',  $(element).attr('title'))
    })
}